import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { formData } from "../../forms";
import { ChangePassword } from "../Input";
import { FormSummary, MainForm, PageHeader } from "./components";
import { addForm, resetForm, setIndex, updateForm } from "../../store/actions/formAction";

import "../../assets/styles/productServices/addProduct.scss";
import { Container, Grid } from "@mui/material";
import useKeyboardShortcuts from "helpers/useKeyboardShortcuts";
import { formShortcuts } from "constants/keyboardConstant";
import Messages from "lang/fa/messages";
import { apiSetAlert } from "api/appApi";

export default function Form({type, modal = false, modalProps}) {
    const {id} = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const form = formData(type);
    const token = useSelector((state) => state).businessReducer.business?.token;

    const page = useSelector((state) => state).formReducer.page;
    const forms = useSelector((state) => state.formReducer.forms);
    const editItem = useSelector((state) => state.formReducer.editItem);
    const financialsState = useSelector((state) => state.financialReducer);
    const activeIndex = useSelector((state) => state).formReducer.activeIndex ?? 0;
    const updateFlag = useSelector((state) => state).formReducer.updateFlag;

    const [activeTab, setActiveTab] = useState(null);

    useEffect(() => {
        if (id) {
            dispatch(resetForm());
            if (type === "financial") {
                const financials = [...financialsState.banks, ...financialsState.funds, ...financialsState.cashiers];
                const financial = financials.find((f) => f.id == id);
                if (financial) {
                    dispatch(form.getFunction(id, token, financial.type));
                }
            } else {
                dispatch(form.getFunction(id, token));
            }
        } else {
            dispatch(resetForm(form.key));
            updateTab();
        }
    }, []);

    useEffect(() => {
        updateTab();
    }, [activeIndex, updateFlag]);

    useEffect(() => {
        let tab = form.tabs.find((f) => f.key === activeTab);
        if (activeTab !== null && !tab) {
            tab = form.tabs[0];
        }

        if (tab) {
            changeActiveTab(tab.key, tab.name);
        }
    }, [activeTab]);

    const changeActiveTab = (key, title) => {
        setActiveTab(key);
        dispatch(updateForm("formType", key));
        dispatch(updateForm("formTypeTitle", title));
    };

    const updateTab = () => {
        if (location.state?.type) {
            setActiveTab(location.state?.type);
        } else {
            const activeForm = forms.find((form) => form.index === activeIndex);
            if (
                page === form.key &&
                activeForm &&
                activeForm.main.accountingCodeType &&
                activeForm.others.formType
            ) {
                changeActiveTab(activeForm.others.formType, activeForm.others.formTypeTitle);
            } else {
                const tab = form.tabs[0];
                changeActiveTab(tab.key, tab.name);
            }
        }
    };

    const {AddedInfo} = form;

    const submit = () => {
        if (id) {
            dispatch(form.updateFunction(id, forms[0], token, navigate, modalProps));
        } else {
            dispatch(form.addFunction(forms, token, navigate, modalProps));
        }
    };

    // handle what happens on key press
    const handleKey = (val) => {
        // Perform save action

        const nextForm = () => {
            try {
                if (activeIndex + 1 < forms?.length) {
                    dispatch(setIndex(activeIndex + 1));
                }
            } catch (error) {
                dispatch(setIndex(activeIndex));
            }
        };
        const prevForm = () => {
            try {
                if (activeIndex > 0) {
                }
                dispatch(setIndex(activeIndex - 1));
            } catch (error) {
                dispatch(setIndex(activeIndex));
            }
        };

        switch (val.key) {
            case "keyboardShortcutNewForm":
                if (editItem) {
                    dispatch(apiSetAlert(Messages.cannotAddFormOnEdit, "warning"));
                } else if (forms.length < 10) {
                    dispatch(addForm());
                } else {
                    dispatch(apiSetAlert(Messages.maxFormsReached, "warning"));
                }
                break;
            case "keyboardShortcutResetForm":
                dispatch(resetForm(form.key));
                break;
            case "keyboardShortcutPrevForm":
                dispatch(setIndex(0));
                break;
            case "keyboardShortcutNextForm":
                nextForm();
                break;
            case "keyboardShortcutSaveForm":
                submit();
                break;
            case "keyboardShortcutSaveDraft":
                break;
            default:
                break;
        }
    };
    useKeyboardShortcuts(formShortcuts, handleKey);
    //== keyboard shortcut

    return (
        <Container maxWidth="lg">
            <div className="wrap-add-product">
                {!modal && <PageHeader header={form.navigation} activeTab={activeTab}/>}
                <Grid container spacing={4} className="mt-0">
                    <Grid item xl={8} lg={8} md={12} sm={12} xs={12}>
                        <MainForm form={form} activeTab={activeTab} setActiveTab={setActiveTab}/>
                        {AddedInfo && <AddedInfo/>}
                        {/* <div
                className={`col-lg-4 col-md-12 col-sm-12 col-xs-12 ${modal ? '' : 'mt-3'}`}
                > */}
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={8} xs={12}>
                        {form.summaryInfo ? (
                            <FormSummary summaryInfo={form.summaryInfo} submit={submit} isEdit={id}/>
                        ) : (
                            <ChangePassword/>
                        )}

                        {/* </div> */}
                    </Grid>
                </Grid>
            </div>
        </Container>
    );
}
